import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Constants from '../../model/AppConfiguration';
import { AppBar, Typography, withStyles } from 'material-ui';
import Tabs, { Tab } from 'material-ui/Tabs';
import TabStyles from './RouteTabStyles';
import SideTabsStyles from './RouteSideTabsStyles';
import TabsStyles from './RouteTabsStyles';
import FlightsScreenController from '../flights/FlightsScreenController';
import RouteTabsProps from './RouteTabsProps';
import PlaneIcon from '../../icons/PlaneIcon';
import DesktopPlane from '../../icons/DesktopPlane';
import DesktopActivePlane from '../../icons/DesktopActivePlane';
import ClassNames from 'classnames';
import ColorPalette from '../../components/styling/ColorPalette';
import StyledComponent from '../../components/styling/StyledComponent';
import './RouteTabs.css';

/**
 * ## Redux imports
 */
import * as flightsActions from '../../redux/actions/FlightsActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../redux/selectors/Index';
import ProgressBarCenter from '../../components/ProgressBarCenter';

/**
 * ## Redux boilerplate
 */
const actions = [ flightsActions ];

function mapStateToProps (state) {
  return {
    flights: selectors.flights.getFlights(state.flights),
    routes: selectors.routes.getRoutes(state.routes),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

const TabContainer = props => (
  <Typography
    component='div'
    style={{
      top: '60px',
      width: '100%',
      height: '100%',
      display: 'block',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    {props.children}
  </Typography>
);

TabContainer.propTypes = { children: PropTypes.node.isRequired };

class RouteTabs extends Component {
  static propTypes = RouteTabsProps;

  constructor (props) {
    super(props);

    let routeId = props.selectedRoute ? props.selectedRoute.id : 1;
    this.state = {
      selectedTab: routeId,
      routes: this.setRoutes(props),
    };
  }

  componentWillReceiveProps (props) {
    if (props.flights && props.flights.length) {
      this.setState({ routes: this.setRoutes(props) });
    }
  }

  setRoutes = props => {
    let routes = [];
    let flights = props.flights;
    if (flights && flights.length) {
      for (let i = 0; i < flights.length; i++) {
        let flight = flights[ i ];
        if (flight.routeId) {
          let route = selectors.routes.getRouteByFlight(props.routes, flight.routeId);
          routes.push(route);
        }
      }
    }
    return routes;
  };

  generateTabName = (route, selectedTab, index) => {
    const { isMain } = this.props;
    if (!route || !route.id || !selectedTab || !selectedTab.id) {
      return '';
    }
    let departure = isMain ? route.arrival : route.arrival.slice(0, 3);
    let arrival = isMain ? route.departure : route.departure.slice(0, 3);

    return (
      <span className='tab-icon-text-wrapper'>
        {isMain ? (
          <span className='desktop-plane-wrapper'>
            &nbsp;&nbsp;
            {index === 0 ? (
              <DesktopPlane
                className={ClassNames({
                  'desktop-plane-selected': route.id === selectedTab.id,
                  'desktop-plane-default': route.id !== selectedTab.id,
                })}
              />
            ) : (
              <DesktopActivePlane
                className={ClassNames({
                  'desktop-plane-selected': route.id === selectedTab.id,
                  'desktop-plane-default': route.id !== selectedTab.id,
                })}
              />
            )}&nbsp;
          </span>
        ) : null}
        <span className='route-name'>
          {departure}
          {isMain ? (
            ' - '
          ) : (
            <span>
              &nbsp;&nbsp;
              <PlaneIcon
                className={ClassNames({
                  'plane-selected': route.id === selectedTab.id,
                  'plane-default': route.id !== selectedTab.id,
                })}
              />&nbsp;
            </span>
          )}
          {arrival}
          <div className='route-date-time'>
            <span className='route-date'>{this.generateTabDate(route)}</span>
            <span className='route-time'>{this.generateTabTime(route)}</span>
          </div>
        </span>
      </span>
    );
  };

  generateTabDate = route => {
    if (!route || !route.id) {
      return '';
    }
    let routeId = route.id;
    const { flights, showDate } = this.props;
    let flight = selectors.flights.getFlight(flights, routeId);
    if (showDate && flight && flight.date) {
      return FlightsScreenController.formatDateLongMonthWithDay(flight.date);
    }
    return '';
  };

  generateTabTime = route => {
    if (!route || !route.id) {
      return '';
    }
    let routeId = route.id;
    const { flights, showDate } = this.props;
    let flight = selectors.flights.getFlight(flights, routeId);
    if (showDate && flight && flight.time) {
      let time = flight.time.toLowerCase();
      time.replace('am', ' am');
      time.replace('pm', ' pm');
      return ` ${flight.time}`;
    }
    return '';
  };

  render () {
    const {
      selectedRoute,
      selectedTrip,
      TabContent,
      toggleRoutes,
      centered,
      isMain,
      classes,
    } = this.props;
    const { routes } = this.state;

    if (!routes || !selectedRoute || !selectedRoute.id) {
      return (
        <div id='route-tabs'>
          <ProgressBarCenter />
        </div>
      );
    }

    let isRoundTrip = selectedTrip && selectedTrip.id === Constants.flights.roundTrip;
    const StyledTabs = isMain ?
      StyledComponent(Tabs)(TabsStyles) :
      StyledComponent(Tabs)(SideTabsStyles);

    return (
      <div id='route-tabs'>
        <AppBar
          position='static'
          style={{
            backgroundColor: isMain ? '#ebeefa' : ColorPalette.navigationBgBlue,
            borderRadius: isMain ? 9 : 0,
            width: centered ? '100%' : isRoundTrip ? 528 : 264,
            minWidth: isMain ? 264 : 'inherit',
            boxShadow: 'none',
          }}
        >
          <StyledTabs
            value={selectedRoute.id}
            onChange={toggleRoutes}
            indicatorColor='none'
            textColor={isMain ? 'primary' : 'secondary'}
            centered={centered}
            fullWidth={centered}
          >
            {routes.map(
              (route, index) =>
                index === 0 || (index > 0 && isRoundTrip) ? (
                  <Tab
                    value={route ? route.id : ''}
                    key={`${route ? route.id : ''}-${index}`}
                    icon={<div>{this.generateTabName(route, selectedRoute, index)}</div>}
                    classes={classes}
                    style={{ minWidth: isRoundTrip ? 'inherit' : 'calc(100% - 5px)' }}
                  />
                ) : null
            )}
          </StyledTabs>
        </AppBar>

        {TabContent}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TabStyles)(RouteTabs));



// WEBPACK FOOTER //
// ./src/containers/routeTabs/RouteTabs.js